import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { config } from '../config'

interface NavigationProps {
  onContactClick?: () => void
}

const Navigation: React.FC<NavigationProps> = ({ onContactClick: _ }) => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
    setIsMobileMenuOpen(false)
  }

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'glass-card-intense border-b border-brand-blue/20' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img src="/icon.png" alt="Universal Pays Logo" className="w-8 h-8" />
            <span className="text-xl font-bold gradient-text">Universal Pays</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-300 hover:text-brand-blue transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-300 hover:text-brand-blue transition-colors"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-gray-300 hover:text-brand-blue transition-colors"
            >
              FAQ
            </button>
            <a
              href={config.links.login}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-brand-blue transition-colors"
            >
              Login
            </a>
            <a
              href={config.links.signup}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-2 rounded-lg hover:shadow-lg transition-all duration-300 neon-glow inline-block text-center"
            >
              Sign Up
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-300 hover:text-white"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden glass-card-intense border-t border-brand-blue/20">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <button
                onClick={() => scrollToSection('services')}
                className="block px-3 py-2 text-gray-300 hover:text-brand-blue transition-colors w-full text-left"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('features')}
                className="block px-3 py-2 text-gray-300 hover:text-brand-blue transition-colors w-full text-left"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection('faq')}
                className="block px-3 py-2 text-gray-300 hover:text-brand-blue transition-colors w-full text-left"
              >
                FAQ
              </button>
              <a
                href={config.links.login}
                target="_blank"
                rel="noopener noreferrer"
                className="block px-3 py-2 text-gray-300 hover:text-brand-blue transition-colors w-full text-left"
              >
                Login
              </a>
              <a
                href={config.links.signup}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full mt-4 bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-2 rounded-lg hover:shadow-lg transition-all duration-300 neon-glow inline-block text-center"
              >
                Sign Up
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navigation
